import { render, staticRenderFns } from "./ViewportList.vue?vue&type=template&id=97fc39b2&scoped=true"
import script from "./ViewportList.vue?vue&type=script&lang=js"
export * from "./ViewportList.vue?vue&type=script&lang=js"
import style0 from "./ViewportList.vue?vue&type=style&index=0&id=97fc39b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fc39b2",
  null
  
)

export default component.exports